import React from 'react';
import ContentWrapper from '../components/ContentWrapper';
import Team from '../components/Team';
import Title from '../images/titles/kontakt.svg';
import { useT } from '../i18n';


const About = () => {
    const t = useT();
    return  <ContentWrapper>
        <img src={Title} alt={t('Kontakt', 'Contact')} className="w-72 text-center mx-auto mt-16 mb-12" />
        <p className="max-w-2xl mx-auto text-center px-4">
          {t(
            `The Branch AS er ikke lenger i drift, men vi er fortsatt å nå hver for oss.
            Flere av oss er åpne for nye jobber og oppdrag innen animasjon, så ta gjerne direkte kontakt.`,
            `The Branch AS is no longer in operation, but each of us can still be reached individually.
            Several of us are open to new jobs and animation projects, so feel free to get in touch directly.`
          )}
        </p>
        <Team />
      </ContentWrapper>
}

export default About;
